import {cn} from '@lib/utils';

interface PercentCellProps {
  value: number;
  hiThreshold?: number;
  midThreshold?: number;
  className?: string;
}

/** Процентное значение с пороговыми цветами. */
export const PercentCell = ({
  value,
  hiThreshold = 75,
  midThreshold = 55,
  className,
}: PercentCellProps) => {
  const colorClass =
    value >= hiThreshold
      ? 'text-[var(--score-good)]'
      : value >= midThreshold
        ? 'text-[var(--score-warn)]'
        : 'text-[var(--score-bad)]';

  return (
    <span className={cn('text-sm font-medium', colorClass, className)}>
      {value}%
    </span>
  );
};
